import React from 'react'
import styled from "styled-components";

const Boton = styled.button`
    background-color: ${({ theme }) => theme.success || '#28a745'};
    color: #FFF;
    border: none;
    transition: ease-in-out 200ms; 
    cursor: pointer;   
    display: inline-flex;
    padding: 0.15rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5; 
    border-radius: 0.2rem;
    justify-content: center;
    &:hover {
        background-color: ${({ theme }) => theme.successHover || '#1d8a35'};
        border-color: ${({ theme }) => theme.successHover || '#1d8a35'};
        color: #FFF;
    }
`;

export default function BotonSuccess({ children, onClick, ancho, className, ...rest } ) {
    return <Boton
        {...rest}
        onClick={onClick}
        style={{width: ancho}}
        className={className}
    >
            {children}
    </Boton> 
}